import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

const navItems = [
	{
		id: 1,
		title: "/about",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth="1.5"
				stroke="currentColor"
				className="size-[28px]">
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
				/>
			</svg>
		),
	},
	// {
	// 	id: 2,
	// 	title: "/projects",
	// 	icon: (
	// 		<svg
	// 			xmlns="http://www.w3.org/2000/svg"
	// 			fill="none"
	// 			viewBox="0 0 24 24"
	// 			strokeWidth="1.5"
	// 			stroke="currentColor"
	// 			className="size-[28px]">
	// 			<path
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 				d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
	// 			/>
	// 		</svg>
	// 	),
	// },
	// {
	// 	id: 3,
	// 	title: "/articles",
	// 	icon: (
	// 		<svg
	// 			xmlns="http://www.w3.org/2000/svg"
	// 			fill="none"
	// 			viewBox="0 0 24 24"
	// 			strokeWidth="1.5"
	// 			stroke="currentColor"
	// 			className="size-[28px]">
	// 			<path
	// 				strokeLinecap="round"
	// 				strokeLinejoin="round"
	// 				d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z"
	// 			/>
	// 		</svg>
	// 	),
	// },
	{
		id: 4,
		title: "/contact",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth="1.5"
				stroke="currentColor"
				className="size-[28px]">
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
				/>
			</svg>
		),
	},
];

const mobileNavVariants = {
	initial: {
		y: -10,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 0.75,
	},
	exit: {
		y: -10,
		opacity: 0,
	},
	transition: {
		duration: 0.5,
	},
};

const MobileNavbar = () => {
	const { pathname } = useLocation();
	const { theme, openDrawer, setOpenDrawer } = useTheme();

	const navMenu = navItems.map((navItem) => (
		<motion.li
			key={navItem.id}
			className="list-none inline-flex flex-col items-center justify-center gap-0.5 transition-all duration-250">
			<Link
				to={navItem.title}
				className="text-xl flex items-center justify-evenly gap-1"
				onClick={() => setOpenDrawer((prev) => !prev)}>
				{navItem.icon}
				{navItem.title}
			</Link>
		</motion.li>
	));

	return (
		<>
			<AnimatePresence>
				{openDrawer && (
					<motion.div
						variants={mobileNavVariants}
						{...mobileNavVariants}
						className={`min-w-full min-h-20 z-50 absolute py-5 flex flex-col gap-5 ${
							theme === "dark" ? "bg-black" : "bg-white"
						}`}>
						{navMenu}
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
};

export default MobileNavbar;
